<section class="main-body">
    <fitscovery-ui-navbar [component]="component"></fitscovery-ui-navbar>
    <section class="main-content pb-lg-4">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
    </section>
    <fitscovery-ui-bottom-navbar></fitscovery-ui-bottom-navbar>
    <fitscovery-ui-footer></fitscovery-ui-footer>
</section>